import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import '../../assets/css/footer.css';
import '../../assets/css/animated.css';
import NavBarLandingPage from './NavBarLandingPage';
import FooterLandingpage from './FooterLandingpage';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Paper from '@mui/material/Paper';
import EmailHelp from '../../assets/images/emailhelpcenter.svg';
import PhoneHelp from '../../assets/images/phonehelpcenter.svg';
import PinkCircle from '../../assets/images/pinkcircledot.svg';
import Yellowish from '../../assets/images/yellowishcircular.svg';
import BlueCircular from '../../assets/images/bluecircularround.svg';
import VerticalS from '../../assets/images/sverticalplaced.svg';
import whiteCircle from '../../assets/images/whitecirclevector.svg';
import zIndex from '@mui/material/styles/zIndex';
function HelpCenter() {
    const styles = {
        typography: {
          fontFamily:'Sofia Sans Extra Condensed',
          fontSize: '60px',
      fontWeight: 700,
      lineHeight: '60px',
      letterSpacing: '0em',
      textAlign: 'center',
          '@media (max-width: 600px)': {
            fontSize: '32px', // Adjust the font size for smaller screens
          },
        },
        // Other styles...
      };
      const otherStyles = {
        typography: {
          fontFamily:'Sofia Sans Extra Condensed',
          '@media (max-width: 600px)': {
            fontSize: '22px', // Adjust the font size for smaller screens
          },
        },
        // Other styles...
      };
      const descriptionStyles = {
        typography: {
          fontFamily:'Roboto Flex',
 fontSize: '28px',
 fontWeight: 500,
 lineHeight: '27px',
 letterSpacing: '0em',
 textAlign: 'center',
          '@media (max-width: 600px)': {
            fontSize: '16px', // Adjust the font size for smaller screens
          },
        },
        // Other styles...
      };
      

      const [expanded, setExpanded] = React.useState(false);
 
      const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : '');
      };
     
  return (
    <div>
      <NavBarLandingPage/>
    <div className='help-center-main landing-page'>
      <Box sx={{padding:'10px'}}>
        <Box sx={{margin:'30px',backgroundColor:'#f1f1f1',padding:"50px",borderRadius:'15px','@media (max-width: 600px)': {margin:"5px"}}}>
        <div style={{ position: 'relative', }}>
  
  <Typography
    sx={{
      ...styles.typography,
      
      color: "#1E53E8",
      marginTop: '50px',
      position: 'relative', // Ensure the text stays in front
      zIndex: 1, // Ensure the text stays in front
    }}
  >
    Help Center
  </Typography>
  <img
    src={Yellowish}
    alt=""
    className='yellowish-circular-bg'
    
  />
  <Typography sx={{
 
 ...descriptionStyles.typography,
 marginBlock: "15px",
 position: 'relative', // Ensure the text stays in front
      zIndex: 1,
}}>
Have any questions? We're here to assist you.
</Typography>
</div>
<div style={{display:'flex',justifyContent:'center',alignItems:'center',marginBlock:'70px'}}>
<TextField
      variant="filled"
      placeholder="Search"
      sx={{width:'500px'}}
      InputProps={{
        startAdornment: (
          <SearchIcon style={{ color: 'gray' }} />
        ),
        
      }}
    />   
</div>
<Box>
    <Typography sx={{
  ...styles.typography,
 
  textAlign: 'center',
  color:'#1E53E8',
  padding:'40px'
}}
>
    Frequently Asked Questions <img src={PinkCircle} alt="" />
    </Typography>
      <Accordion 
        style={{ 
          margin: '0 0 10px 0', 
          border: '3px solid #1E53E8',
          color: 'white',
          padding:'20px'
        }} 
        expanded={expanded === 'panel1'} 
        onChange={handleChange('panel1')}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
          <Typography sx={{
  fontSize: '32px',
  ...otherStyles.typography,
  fontWeight: 600,
  lineHeight: '38px',
  letterSpacing: '0px',
  textAlign: 'left', }}>
            1. What Kind of OS can I use?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ fontSize:'20px' }}>
            - Astra PC supports Windows 10 because this OS delivers very good performance and load balancing.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion 
        style={{ 
          margin: '0 0 10px 0',
          border: '3px solid #1E53E8', 
          color: 'white',
          padding:'20px' // Set text color to white
        }} 
        expanded={expanded === 'panel2'} 
        onChange={handleChange('panel2')}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
          <Typography sx={{
        ...otherStyles.typography,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '38px',
        letterSpacing: '0px',
        textAlign: 'left', }}>
            2. How about Online Games?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ fontSize:'20px' }} >
            - Yes, you can play games.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion 
        style={{ 
          margin: '0 0 10px 0', 
          border: '3px solid #1E53E8', // Set border color to white
          // color: 'white',
          padding:'20px'
        }} 
        expanded={expanded === 'panel3'} 
        onChange={handleChange('panel3')}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
          <Typography sx={{ 

        ...otherStyles.typography,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '38px',
        letterSpacing: '0px',
        textAlign: 'left', }}>
            3. Can I play Videos or Movies with it?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ fontSize:'20px' }}>
            - Yes, Astra PC are simply plug-and-play products designed for durable, high performance. The hardware accelerator reduces peaks in CPU utilization. By creating virtual CPU headroom, the accelerator allows CPU-intensive applications like videos to continue running smoothly.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion 
        style={{ 
          margin: '0 0 10px 0', 
          border: '3px solid #1E53E8', // Set border color to white
          // color: 'white',
          padding:'20px'
        }} 
        expanded={expanded === 'panel4'} 
        onChange={handleChange('panel4')}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
          <Typography sx={{
          ...otherStyles.typography,
  fontSize: '32px',
  fontWeight: 600,
  lineHeight: '38px',
  letterSpacing: '0px',
  textAlign: 'left', }}>
            4. What kind of customer support do you provide?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ fontSize:'20px' }}>
            - You don’t have to worry about customer support. Just contact us directly on the phone or email us, we will inspect your network and Astra PC and immediately provide solutions to any Astra PC-related problems..! Over calls or through RDP application by login to server PC remotely, and if you need local support, we have Astra PC support team.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
    </Box>
    <Paper sx={{padding:"80px",backgroundColor:'#b6ffff',borderRadius:'10px',margin:'30px',position:'relative'}}>
      <Grid container spacing={6} sx={{ display: 'flex', alignItems: 'center',justifyContent:'space-between',flexDirection:'column' }}>
        <Grid item xs={12} md={6}>
          <Typography sx={{
             ...otherStyles.typography,
            fontSize: '54px',
            fontWeight: 700,
            lineHeight: '32px',
            letterSpacing: '0em',
            textAlign: 'center',
            marginTop:"20px"
          }}>
            Still have questions?<img src={whiteCircle} alt="" />
          </Typography>
          <Typography sx={{
            ...descriptionStyles.typography,
            fontSize: '22px',
            fontWeight: 300,
            lineHeight: '21px',
            letterSpacing: '0em',
            textAlign: 'center',
            marginTop:"20px"
          }}>
            Can’t find the answer you’re looking for? Please chat to our friendly team.
          </Typography>
        </Grid>
        <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
          <Button variant="contained" sx={{padding:'12px',marginTop:'30px',backgroundColor:'#fff',color:'#1E53E8',fontWeight:'600', fontFamily: "Roboto Flex",zIndex:1}}>
            Live Chat
          </Button>
        </Grid>
      </Grid>
      
      <img src={BlueCircular} alt="" className='blueroundreversible'/>
      
    </Paper>
   

      </Box>
    </div>
    <Box sx={{backgroundColor:'#f1f1f1',padding:"50px",borderRadius:'15px',position:'relative',display:'flex',justifyContent:'space-evenly','@media (max-width: 576px)': {flexDirection:'column',gap:'20px'}}}>
    <div style={{display:'flex',alignItems:'center',gap:'20px'}}>
        <img src={PhoneHelp} alt="" />
        <Typography sx={{
            fontFamily: 'Roboto Flex',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '21px',
            letterSpacing: '0em',
            textAlign: 'left',
            color:'#488CCA'
        }}>
            For Sales<br/>
            <span style={{color:'black'}}>+91 9740002036</span>
        </Typography>
    </div>
    <div style={{display:'flex',alignItems:'center',gap:'20px',zIndex:1}}>
        <img src={EmailHelp} alt="" />
        <Typography sx={{
            fontFamily: 'Roboto Flex',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '21px',
            letterSpacing: '0em',
            textAlign: 'left',
            color:'#488CCA'
        }}>
            For Technical Support<br/>
            <span style={{color:'black'}}>admin@techmega.cloud</span>
        </Typography>
    </div>
    <img src={VerticalS} alt="" style={{position:'absolute',bottom:'0',zIndex:0}} />
</Box>
      <FooterLandingpage />
    </div>
  )
}

export default HelpCenter;
